// lib/list/listOutputObjects.ts
import { z } from 'zod';
import type { ListOutputObjectAssociation } from '#types/types';

const associations = z.array(z.object({
  id: z.string().uuid(), contentRevision: z.number().int().positive().safe(),
  handle: z.string().regex(/^[a-z0-9-]{1,48}$/).optional(), enabled: z.boolean().optional(),
})).max(2);

export function readListOutputObjects(params: unknown): ListOutputObjectAssociation[] | null {
  const record = params && typeof params === 'object' && !Array.isArray(params) ? params as Record<string, unknown> : {};
  const parsed = associations.safeParse(record.listObjectContext ?? record.listObjects ?? []);
  if (!parsed.success) return null;
  const disabled = record.listObjectDisabled && typeof record.listObjectDisabled === 'object' && !Array.isArray(record.listObjectDisabled) ? record.listObjectDisabled as Record<string, unknown> : {};
  return parsed.data.map(object => ({ ...object, enabled: typeof disabled[object.id] === 'boolean' ? !disabled[object.id] : object.enabled !== false }));
}
